import challenge from 'services/challenge/challenge';
import submission from 'services/challenge/submission';
import awardedPlace from 'services/challenge/awardedPlace';

export default {
	...challenge,
	...submission,
	...awardedPlace,
};
